import React, { useEffect, useState } from 'react'
import SuccessStory from '../../CertificateVerification/SuccessStory'
import PlacementSuccessStory from '../../../components/PlacementSuccessStory'
import Faq from '../../CertificateVerification/Faq'
import ChooseNextCertificate from './ChooseNextCertificate'
import NewRecognisedSection from '../../../components/NewRecognisedSection'
import LcpCertificate from './LcpCertificate'
import { useDispatch, useSelector } from 'react-redux'
import { capitalizeWords } from '../../../utils/subscription'
import { SET_ONBOARDING_IS_LOADING } from '../../../redux/actions/types'
import { Mixpanel } from '../../../config/Mixpanel'
import Constants from '../../../common/constants'
import OnBoardingFaq from '../onBoardingFaq'
import HowItWorks from '../HowItWorks'
import DesktopHowItWorks from '../DesktopHowItWorks'
const Certificate = ({handleOnboardingCompletion, handleSetIsLoading, handleOnboardingCompletionWithoutRedirection}) => {
    const [swiperInstance, setSwiperInstance] = useState(null)
    const goal = useSelector((store) => store?.onBoarding?.goal) || "";
    const dispatch = useDispatch();
    
    useEffect(() => {
        Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_CERTIFICATE_PAGE_LOADED);
    }, []);

    

  return (
    <div className='w-full'>
        <div className='font-semibold leading-[130%] text-[28px] text-center text-[#DED996] tracking-[-0.1]'>Get Hired As A {capitalizeWords(goal)} With a Certificate Trusted by 1100+ Companies</div>
        <div className='mt-8'>
            <LcpCertificate handleSetIsLoading={handleSetIsLoading} handleOnboardingCompletion={handleOnboardingCompletion} handleOnboardingCompletionWithoutRedirection={handleOnboardingCompletionWithoutRedirection}/>
        </div>
        <div className='mt-12 text-center'>
            <div className='text-[16px]  text-white/50'>Get Certified In</div>
            <div className='text-[24px] font-semibold text-white leading-[130%]'>Under 10 Minutes!</div>
            <img alt="" className='w-full' src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Frame%20427322046.webp"/>
        </div>
        <div className='mt-12 text-center px-3 py-6 rounded-[24px]' style={{backgroundImage : `linear-gradient(
  to bottom,
  rgba(64, 106, 255, 0.10) 0%,
  rgba(64, 106, 255, 0.05) 100%
)`}}>
            <div className='text-[24px]  font-medium text-white'>Your Fastest Way To Get</div>
            <div className='text-[24px] font-bold text-white leading-[130%]'>Recognised In 2026</div>
            {window.innerWidth >= 768 ? <DesktopHowItWorks/> : <HowItWorks/>}
        </div>

        <div className='mt-10'>
            <NewRecognisedSection swiperInstance={swiperInstance} setSwiperInstance={setSwiperInstance}/>
        </div>
        <div className='mt-12'>
            <ChooseNextCertificate handleOnboardingCompletion={handleOnboardingCompletion} handleSetIsLoading={handleSetIsLoading} handleOnboardingCompletionWithoutRedirection={handleOnboardingCompletionWithoutRedirection}/>
        </div>
        <div className='mt-12 w-full flex flex-col items-center justify-center text-center'>
            <div className='text-[16px]  text-white/50'>Success Stories</div>
            <div className='text-[24px] font-semibold text-white mb-4 leading-[130%]'>Real Learners, Real Outcomes</div>
            <PlacementSuccessStory/>
        </div>
        <div className='mt-12'>
            <SuccessStory/>
        </div>
        <div className="mt-12 mb-4 text-center text-[24px] font-semibold text-white">
          Frequently{" "}
          <span className=""> Asked </span>{" "}
          Questions
        </div>
       <OnBoardingFaq/>

    </div>
  )
}

export default Certificate